let copyHandler = {
    'init': function () {
        if (document.getElementById('refCopyBtn')) {
            document.getElementById('refCopyBtn').addEventListener('click', copyHandler._run);
        }
    },
    '_run': function (event) {
        let btn = event.currentTarget,
            copyText = document.getElementById(btn.dataset.textId),
            tooltip = document.getElementById(btn.dataset.tooltipId);

        // for Internet Explorer
        if (document.body.createTextRange) {
            let range = document.body.createTextRange();

            range.moveToElementText(copyText);
            range.select();
            copyHandler._copy(tooltip);
        }
        // for other browsers
        else if (window.getSelection) {

            let selection = window.getSelection(),
                range = document.createRange();

            range.selectNodeContents(copyText);
            selection.removeAllRanges();
            selection.addRange(range);
            copyHandler._copy(tooltip);
            selection.removeAllRanges();
        }
    },
    '_copy': function (tooltip) {
        if (document.execCommand("Copy")) {
            tooltip.innerText = 'Скопировано';
        }
    }
};

copyHandler.init();
  